const trainingTypes = {
  REGULAR_INDUCTION: 'Regular_Induction',
  COLLECTION_TRAINING: 'Collection_Training',
  CORRECTIVE_TRAINING: 'corrective-training',
  INDIVIDUAL_LENDING: 'Individual_Lending',
  TRAILBLAZE_2_0: 'Trailblaze_2.0',
  PRODUCT_FINANCING: 'Product_Financing',
  PRAGATI_TRAINING: 'Pragati_Training',
};

export default trainingTypes;
